import { useState } from "react";
import { Lock, Unlock, Copy, Volume2, Heart } from "lucide-react";
import { toast } from "sonner";
import { MicButton } from "@/components/MicButton";
import { AcornCelebration } from "@/components/AcornCelebration";
import { hasThanks, speak } from "@/lib/api";
import { GratitudeChips } from "@/components/GratitudeChips";
import { GRATITUDE_THANKS } from "@/lib/gratitude";

const ThanksGate = ({ age, onThanks, ready }) => {
  const [val, setVal] = useState("");
  const submit = (t) => {
    if (hasThanks(t)) onThanks(t);
    else toast(age === "kid" ? "Hmm, what do we say when someone helps us?" : "Say “thank you” to unlock.");
  };
  return (
    <div className="pp-overlay" data-testid="blurred-answer-overlay">
      <Lock className="h-8 w-8" />
      <p className="pp-h3">{age === "kid" ? "Say THANK YOU to open your answer!" : "Say “thank you” to finish the directive."}</p>
      <input
        data-testid="thank-you-input-field"
        className="pp-input"
        value={val}
        placeholder="Thank you!"
        onChange={(e) => setVal(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit(val)}
      />
      <GratitudeChips label="Golden thank-you" phrases={GRATITUDE_THANKS[age]} testPrefix="gratitude-thanks" />
      <div className="pp-actions center">
        <MicButton testId="thank-you-mic-button" onText={(t) => { setVal(t); submit(t); }} label="Say it" />
        <button data-testid="submit-thank-you-button" className="pp-primary" disabled={!ready} onClick={() => submit(val)}>
          <Heart className="h-5 w-5" /> Send thanks
        </button>
      </div>
    </div>
  );
};

const Reward = ({ reward }) => {
  const golden = reward.gratitude_request + reward.gratitude_thanks;
  return (
    <p className={`pp-reward ${golden ? "gold" : ""}`} data-testid="acorn-reward">
      <img src="/acorn-t.png" alt="" /> +{reward.acorns} acorn{reward.acorns > 1 ? "s" : ""}
      {golden > 0 && <b> · {golden} golden for gratitude words!</b>}
    </p>
  );
};

export const AnswerCard = ({ age, answer, streaming, unlocked, onThanks, reward }) => (
  <section className={`pp-card ${unlocked ? "gate-ok" : ""}`} data-testid={unlocked ? "unlocked-answer-card" : "locked-answer-container"}>
    <p className="pp-label">{unlocked ? "Step 5 · Directive complete" : "Step 4 · The Thank-You Gate"}</p>
    {unlocked && <AcornCelebration age={age} answer={answer} golden={reward ? reward.gratitude_request + reward.gratitude_thanks : 0} />}
    {unlocked && (
      <div className="pp-gate-head">
        <span className="pp-lock ok"><Unlock className="h-6 w-6" /></span>
        <h2 className="pp-h2" data-testid="completion-message">
          {age === "kid" ? "You're welcome! Wonderful manners." : "You're welcome. Directive complete."}
        </h2>
      </div>
    )}
    {unlocked && reward && <Reward reward={reward} />}
    <div className={`pp-answer-wrap ${unlocked ? "" : "locked"}`}>
      <p className={`pp-answer ${unlocked ? "" : "blurred"}`} data-testid="full-ai-response-text">
        {answer || "Thinking…"}
      </p>
      {!unlocked && <ThanksGate age={age} onThanks={onThanks} ready={!streaming} />}
    </div>
    {unlocked && (
      <div className="pp-actions">
        <button data-testid="copy-answer-button" className="pp-ghost" onClick={() => { navigator.clipboard?.writeText(answer); toast.success("Copied"); }}>
          <Copy className="h-4 w-4" /> Copy
        </button>
        <button data-testid="speak-answer-button" className="pp-ghost" onClick={() => speak(answer)}>
          <Volume2 className="h-4 w-4" /> Read aloud
        </button>
      </div>
    )}
  </section>
);
